import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"width":"20%"} }

import SogPage from "@/shared/ui/SogPage.vue";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import {SogButtonKind} from "@/shared/ui/types/SogButtonKind";
import {ref, onMounted, watch, reactive} from "vue";
import SogTextBox from "@/shared/ui/SogTextBox.vue";
import {storeToRefs} from "pinia";
import {useInsuranceCancelationStore} from "@/modules/InsuranceCancelation/store";
import SogGrid from "@/shared/ui/SogGrid.vue";
import {Api} from "@/shared/services/api";
import {useNavigationStore} from "@/modules/Navigation/store";
import {ColumnModel} from "@syncfusion/ej2-grids/src/grid/models/column";
import {DateTimeColumn, DefaultColumn} from "@/shared/ui/types/SogGridColumnDefinitions";
import {IdType} from "@/shared/model/idType";
import SogDropDownList from "@/shared/ui/SogDropDownList.vue";





export default /*@__PURE__*/_defineComponent({
  __name: 'InsuranceCancelationListPage',
  setup(__props) {


const _insuranceCancelationStore = useInsuranceCancelationStore()
const {listPage: _listPage} = storeToRefs(_insuranceCancelationStore);
const _url = Api.baseUrl + '/InsuranceCancelationList';
const _cancelationList = ref<InstanceType<typeof SogGrid> | null>(null)
const _buttonId = ref("");
const _navigationStore = useNavigationStore();


const _lstStatus = reactive([
  {id: "ToAllow", value: "Zur Prüfung"},
  {id: "Allowed", value: "Genehmigt"},
  {id: "Ordered", value: "Gutgeschrieben"},
  {id: "Rejected", value: "Abgelehnt"},
  {id: "all", value: "Alle"},
]);
const _fields = {text: "value", value: "id"};

const _columns: ColumnModel[] = [
  {
    ...DefaultColumn,
    headerText: "",
    visible: true,
    commands: [
      {
        buttonOption: {
          cssClass: "e-flat",
          iconCss: "e-circle-info e-icons",
          click: onClickDetails,
        },
      },
    ],
    textAlign: "Left",
    uid: "details",
    autoFit: true,
    width: "60px",
  },
  {...DefaultColumn, field: "insuranceNumber", headerText: "VSNR", autoFit: true},
  {
    ...DateTimeColumn,
    field: "cancelationRequestDate",
    headerText: "Stornierungsanfrage",
    allowSorting: false,
    autoFit: true,
  },
  {
    ...DateTimeColumn,
    field: "cancelationDate",
    headerText: "Stornierungsdatum",
    allowSorting: false,
    autoFit: true,
  },
  {
    ...DefaultColumn,
    field: "cancelationStatusDescription",
    headerText: "Stornierungsstatus",
    allowSorting: false,
    autoFit: true,
  },
  {
    ...DefaultColumn,
    field: "personName",
    headerText: "Kunde",
    autoFit: true,
  }
];

async function onClick(args: any) {
  _navigationStore.currentInsuranceCancelationId = args.rowData.id;
  if (_buttonId.value === "details") {
    await _navigationStore.showObject(IdType.InsuranceCancelation, args.rowData.id);
  }
}

async function onClickDetails() {
  _buttonId.value = "details";
}

function search() {
  if (!_cancelationList.value || !_cancelationList.value.adaptor) return;
  _cancelationList.value?.adaptor.removePredicate("number");
  if (_listPage.value.number){
    _cancelationList.value?.adaptor.addPredicate(
      "number",
      "contains",
      _listPage.value.number.toUpperCase()
    );
  }
  _cancelationList.value?.adaptor.removePredicate("personName");
  if (_listPage.value.personName){
    _cancelationList.value?.adaptor.addPredicate(
        "personName",
        "contains",
        _listPage.value.personName.toUpperCase()
    );
  }
  _cancelationList.value?.adaptor?.removePredicate("cancelationStatus");
  if (_listPage.value.status !== "all") {
    _cancelationList.value?.adaptor.addPredicate(
      "cancelationStatus",
      "equal",
      _listPage.value.status
    );
  }

  _cancelationList.value?.refresh();
}

onMounted(() => {
  search();
});

watch(_listPage.value, () => {
  search();
});

function onSearch() {
  search();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogPage, { title: "Stornierungen (beta)" }, {
    default: _withCtx(() => [
      _createVNode(SogCard, null, {
        default: _withCtx(() => [
          _createVNode(SogCardActions, { "is-toolbar": true }, {
            default: _withCtx(() => [
              _createVNode(SogTextBox, {
                modelValue: _unref(_listPage).number,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(_listPage).number) = $event)),
                placeholder: "VR-Nummer",
                "interval-modified": onSearch
              }, null, 8, ["modelValue"]),
              _createVNode(SogTextBox, {
                modelValue: _unref(_listPage).personName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(_listPage).personName) = $event)),
                placeholder: "Kunde",
                "interval-modified": onSearch
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_1, [
                _createVNode(SogDropDownList, {
                  modelValue: _unref(_listPage).status,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(_listPage).status) = $event)),
                  placeholder: "Status",
                  "data-source": _lstStatus,
                  fields: _fields,
                  "popup-width": "auto"
                }, null, 8, ["modelValue", "data-source"])
              ]),
              _createVNode(SogCardActionButton, {
                kind: _unref(SogButtonKind).Search,
                style: {"align-self":"flex-end"},
                onClick: search
              }, null, 8, ["kind"]),
              _createVNode(SogCardActionButton, {
                kind: _unref(SogButtonKind).Back,
                style: {"align-self":"flex-end"}
              }, null, 8, ["kind"])
            ]),
            _: 1
          }),
          _createVNode(SogCardContent, null, {
            default: _withCtx(() => [
              _createVNode(SogGrid, {
                id: "cancelationList",
                ref_key: "_cancelationList",
                ref: _cancelationList,
                url: _url,
                columns: _columns,
                "on-command-click": onClick,
                width: "auto"
              }, null, 512)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})